define('views/content/topic-navigation',[
  "globals",
  "backbone",
  "URIjs"
], function (globals, Backbone, URI) {
  "use strict";

  return Backbone.View.extend({
    initialize: function () {
      var model = this.model;

      if (!globals.onCoverPage()) {
        this.$el.css("display", "inline-block");
      }

      this.$previousLink = this.$(".previous")
      this.$nextLink = this.$(".next")

      this.$previousLink.add(this.$nextLink).not(":disabled").on("click", function () {
        var href = $(this).attr("href");
        if (typeof href !== "undefined" && href !== false) {
          document.getElementById("contentSection").parentElement.scrollTo(0,0)
          var l = model.get("location"),
              base = URI.joinPaths(model.getContentBaseURI(), l.library, l.version, l.language, ""),
              uri = new URI(href).absoluteTo(base.path())
  
          model.updateLocationFromURI(uri);
        }

        return false;
      })

      this.model.on("update", this.render, this);

      if (!globals.onCoverPage()) {
        this.model.fetch({
          success: _.bind(function (model) {
            this.render(model)
          }, this)
        })
      }

      this.setupKeyboardNavigation();
    },

    setupKeyboardNavigation: function () {
      $(document).keydown(_.bind(function (event) {
        if(document.activeElement.localName != "textarea") {
          switch(event.which) {
            case 37: {
              this.$previousLink.click();
              break;
            } // left

            case 39: {
              this.$nextLink.click();
              break;
            } // right

            default: {
              return;
            }
          }
        }
      }, this));

      return this;
    },

    render: function (model) {
      var previous = model.get("previous"),
          next = model.get("next");

      if (!globals.onCoverPage() && this.$el.is(":hidden")) {
        this.$el.css("display", "inline-block");
      }

      if (_.isUndefined(previous) || previous === "#") {
        this.$previousLink.removeAttr("href").attr("disabled", "disabled");
      } else {
        this.$previousLink.removeAttr("disabled").attr("href", previous);
      }

      if (_.isUndefined(next) || next === "#") {
        this.$nextLink.removeAttr("href").attr("disabled", "disabled");
      } else {
        this.$nextLink.removeAttr("disabled").attr("href", next);
      }

      return this;
    }
  })
});

